import { motion } from "framer-motion";

/**
 * Reusable hero header for inner pages.
 * Props: eyebrow, title (React node), subtitle, accent ('cyan' | 'warm')
 */
export default function PageHero({ eyebrow, title, subtitle, accent = "cyan", children }) {
  const glow = accent === "warm"
    ? "from-neon-orange/20 to-transparent"
    : "from-neon-cyan/20 to-transparent";

  return (
    <section className="relative pt-40 pb-20 sm:pt-48 sm:pb-24 overflow-hidden" data-testid="page-hero">
      <div className={`absolute inset-0 -z-10 bg-gradient-to-b ${glow}`} />
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(60rem_30rem_at_50%_-10%,rgba(138,43,226,0.18),transparent_60%)]" />
      <svg className="absolute inset-0 -z-10 deco opacity-[0.08]" width="100%" height="100%">
        <defs>
          <pattern id="phg" width="56" height="56" patternUnits="userSpaceOnUse">
            <path d="M 56 0 L 0 0 0 56" fill="none" stroke="white" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#phg)" />
      </svg>

      <div className="container-x relative">
        {eyebrow && (
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="overline mb-5"
          >
            {eyebrow}
          </motion.p>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.08 }}
          className="text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[0.95] uppercase max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-6 text-white/65 text-base sm:text-lg max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
